import { h } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import { APARTMENT_FORM_TYPE } from "../../ApartmentForm.types";
import { Fancybox } from "@fancyapps/ui";

export default function DebtStep({ formContext, onNext, type }) {
  const { formData } = useContext(formContext);
  const {
    address,
    accountNumber,
    debtAmount = "н/д",
    contractId,
  } = formData;
  const [selectedOption, setSelectedOption] = useState(null);

  const handleNext = (status) => {
    setSelectedOption(status);
  };

  const handleConfirm = () => {
    if (selectedOption === "not_mine" && type === APARTMENT_FORM_TYPE.BUY) {
      Fancybox.show([{ src: "#debt-modal", type: "inline" }]);
      return;
    }
    if (selectedOption) {
      onNext({ debtStatus: selectedOption });
    }
  };

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      showClass: "f-fadeIn",
    });
  }, []);

  return (
    <div className="debt-step">
      <div className="debt-info">
        <p>{address}</p>
        <span>ЛС {accountNumber}</span>
      </div>

      <h1>Данные о задолженности</h1>

      <div className="debt-amount">
        <p>
          По данному лицевому счету имеется задолженность{" "}
          <span>{debtAmount} руб</span>
        </p>
      </div>

      <div className="debt-actions">
        <button
          className={`button-secondary button-secondary_border-orange ${
            selectedOption === "paid" ? "active" : ""
          }`}
          onClick={() => handleNext("paid")}
        >
          Оплатить
        </button>

        {type === APARTMENT_FORM_TYPE.BUY && (
          <button
            className={`button-secondary button-secondary_border-gray ${
              selectedOption === "confirmed" ? "active" : ""
            }`}
            onClick={() => handleNext("confirmed")}
          >
            Это мои начисления
          </button>
        )}

        <button
          className={`button-secondary button-secondary_border-gray ${
            selectedOption === "not_mine" ? "active" : ""
          }`}
          onClick={() => handleNext("not_mine")}
        >
          Это не мой долг
        </button>
      </div>

      <div className="debt-actions">
        {selectedOption === "paid" ? (
          <button
            data-modal-url={`/order/contract-pay/?contractId=${contractId}&accountId=${accountNumber}`}
            className="button-primary button-primary_bgc_brand-2"
            onClick={handleConfirm}
          >
            Перейти к оплате
          </button>
        ) : (
          <button
            className="button-primary"
            onClick={handleConfirm}
            disabled={!selectedOption}
          >
            Далее
          </button>
        )}
      </div>

      {type === APARTMENT_FORM_TYPE.BUY && (
        <div id="debt-modal" style={{ display: "none" }}>
          <div className="modal-1 testimony-modal page__testimony-modal">
            <button
              className="modal-1__close-btn"
              aria-label="Закрыть"
              data-fancybox-close
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M12.6663 4.27333L11.7263 3.33333L7.99967 7.06L4.27301 3.33333L3.33301 4.27333L7.05967 8L3.33301 11.7267L4.27301 12.6667L7.99967 8.93999L11.7263 12.6667L12.6663 11.7267L8.93967 8L12.6663 4.27333Z"
                  fill="black"
                />
              </svg>
            </button>

            <div className="modal-1__section">
              <p className="testimony-modal__text">
                Для смены собственника по адресу направьте документы,
                подтверждающие право собственности
              </p>
              <p
                className="testimony-modal__text"
                style={{ margin: "20px 0", color: "#80869B" }}
              >
                (Свидетельство о регистрации права собственности/выписка
                ЕГРП/выписка ЕГРН); Документ – основание для вступления в право
                собственности (Договор купли-продажи с отметкой о регистрации
                права); Акт приема-передачи жилого помещения (в акте должны быть
                указаны показания)
              </p>
              <p className="testimony-modal__text">
                через раздел личного кабинета «Задать вопрос» указав, что долг
                принадлежит прежнему собственнику.
              </p>
              <button
                className="button-primary modal-1__button"
                data-fancybox-close
              >
                Понятно
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
